const DEFAULT_ONBOARDING_COMPLETION_DESTINATION = "/welcome";

export function getOnboardingCompletionDestination(redirect?: string): string {
  if (!redirect) return DEFAULT_ONBOARDING_COMPLETION_DESTINATION;
  return `${DEFAULT_ONBOARDING_COMPLETION_DESTINATION}?${new URLSearchParams({ redirect })}`;
}
